import "./DotLoader.css"; // include the CSS below

const DotLoader = ({ color = "#007bff" }) => {
    return (
        <div className="loader">
            <div className="dot-spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
                <div className="dot3"></div>
            </div>
        </div>
    );
};

export default DotLoader;